<script>
import { fabric } from 'fabric';
import ImageBoxTool from './ImageBoxTool';

export default {
  name: 'AddRectImageBoxTool',
  extends: ImageBoxTool,
  data() {
    return {
      icon: 'square',
    };
  },
  methods: {
    action() {
      this.addRect();
    },
    addRect() {
      const rect = new fabric.Rect({
        top: 100,
        left: 100,
        width: 60,
        height: 70,
        fill: this.parent.fillColor,
        strokeWidth: 5,
        stroke: this.parent.strokeColor,
      });
      this.canvas.add(rect);
    },
  },
};
</script>
